import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import nodeinstance from "../../../../nodeInstance";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";
import { getVisaRequestData } from "../../../../store/Api";
import CommonreturnPopUp from "../../../../ReusableComponents/VRFRequestPopUp";

export default function PaymentPopup({
  setShowPromptElement,
  showPromptElement,
  propData,
}) {
  console.log("kkkkkkkk.....................sssssss", propData);
  const [file, setFile] = useState();
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState();
  const handleAmountChange = (event) => {
    setAmount(event.target.value);
  };
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const [date, setDate] = useState(null);
  const handleDateChange = (event) => {
    console.log("event to be seen here.......", event);
  };
  const submitHandler = async (e, fileData) => {
    console.log("fileData......", fileData, file);
    e.preventDefault();
    setLoading(true);
    if (amount === 0) {
      alert("error");
    }
    if (propData.status === "REFUND INITIATED") {
      try {
        if (parseInt(amount) != parseInt(propData.amount)) {
          dispatch(
            setAppError({
              msg: "Refund amount is not equal to amount paid",
            })
          );
          setLoading(false)
          return;
        }

        const formData = new FormData();
        formData.append("file", file);
        formData.append("Refund_received_date", date);
        formData.append("Refund_amount", amount);
        console.log("ycgyuduyguggu.......", formData);
        if (fileData) {
          // formData.append("file", file);
          const response = await nodeinstance.put(
            `/dashboard/vrf-visa/financerefund/${propData.id}`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
              },
            }
          );
          if (response.status === 200) {
            setShowPromptElement(false);
            dispatch(getVisaRequestData(token));
            setLoading(false)
            dispatch(
              setAppError({
                msg: "Successfully uploaded.",
                color: "success",
              })
            );
          }
          console.log("success to be seen here......", response);
        }
      } catch (err) {
        console.log("error", err);
        setLoading(false)
      }
      return;
    }
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("Date", date);
      formData.append("amount", amount);
      console.log("ycgyuduyguggu.......", formData);
      if (fileData) {
        // formData.append("file", file);
        const response = await nodeinstance.put(
          `/dashboard/vrf-visa/updateVRFByFinance/${propData.id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response.status === 200) {
          setShowPromptElement(false);
          dispatch(getVisaRequestData(token));
          setLoading(false)
          dispatch(
            setAppError({
              msg: "Successfully uploaded.",
              color: "success",
            })
          );
        }
        console.log("success to be seen here......", response);
      }
    } catch (err) {
      console.log("error", err);
      setLoading(false)
    }
  };
  const [DeletepopUp, setDeletePopUp] = useState(false);

  const handleRejectClick = () => {
    setDeletePopUp(true);
    // setShowPromptElement(false);
  };
  console.log("propData.....propData", propData);

  const onPaymentApprove = async () => {
    try {
      let reqObject = {
        status: "REFUND COMPLETED",
      };
      const response = await nodeinstance.put(
        `/dashboard/vrf-visa/updateStatus/${propData.id}`,
        reqObject,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setShowPromptElement(false);
        dispatch(
          setAppError({
            msg: "Updates Successfully...",
            color: "success",
          })
        );
        // setDeletePopUp(false);
        // setShowPromptElement(false)
        dispatch(getVisaRequestData(token));
      }
    } catch (error) {
      console.log("error to be seen here....", error);
      setDeletePopUp(false);
      dispatch(
        setAppError({
          msg: error.message,
          // color : "success"
        })
      );
    }
  };
  return (
    <>
      <>
        {DeletepopUp ? (
          <CommonreturnPopUp
            DeletepopUp={DeletepopUp}
            setDeletePopUp={setDeletePopUp}
            propId={propData.id}
            setShowPromptElement={setShowPromptElement}
            status={"FINANCE REJECTED"}
            CommonreturnPopUp={false}
          />
        ) : (
          <div
            className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
              showPromptElement ? "flex" : "hidden"
            }`}
          >
            <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
              <div className="flex justify-between items-center w-full">
                <h1
                  className="text-md font-semibold cursor-pointer"
                  onClick={() => {
                    setShowPromptElement(false);
                  }}
                >
                  <IoMdClose />
                </h1>
              </div>
              <form onSubmit={(e) => submitHandler(e, file)} className="w-full">
                <div className="w-full flex flex-col gap-3 my-3 p-5">
                  <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                    <label htmlFor={`addOrEdit-name`} className="text-xs ">
                      {propData.status === "REFUND INITIATED"
                        ? "REFUND RECEIVED DATE"
                        : "PAYMENT DONE DATE"}
                    </label>
                    <input
                      type="Date"
                      value={date}
                      max={new Date().toISOString().split('T')[0]} 
                      className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                      onChange={(e) => {
                        setDate(e.target.value);
                      }}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                  </div>
                  <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                    <label htmlFor={`addOrEdit-name`} className="text-xs ">
                      {propData.status === "REFUND INITIATED"
                        ? "REFUND AMOUNT"
                        : "AMOUNT"}
                    </label>
                    <input
                      type="number"
                      className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                      onChange={handleAmountChange}
                    />
                  </div>
                  <div className="form-control w-full ">
                    <label className="label">
                      <span className="label-text">Upload File</span>
                    </label>
                    <input
                      type="file"
                      className="file-input file-input-bordered w-full "
                      onChange={(e) => setFile(e.target.files[0])}
                      required
                      accept="image/*, application/doc, application/docx, application/pdf, application/xls, application/xlsx"
                    />
                  </div>
                  <div
                    className="flex gap-3 w-full justify-center"
                    style={{ m: 2 }}
                  >
                    {propData.status === "REFUND INITIATED" ? (
                      ""
                    ) : (
                      <button
                        className="p-2 bg-blue text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                        onClick={() => {
                          handleRejectClick();
                        }}
                      >
                        {" "}
                        <p>REJECT</p>
                      </button>
                    )}
                    <button
                      type="submit"
                      className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                    >
                      {" "}
                      <p>Submit</p>
                      {loading ? <CgSpinner className="animate-spin" /> : ""}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </>
    </>
  );
}
